<!-- <div class="list-container">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">List of Approved Venders</h4>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Vendor Name</th>
                    <th scope="col">Vendor Phone</th>
                    <th scope="col">Vendor Email</th>
                    <th scope="col">Vendor Status</th>
                    <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let list of vendorList | paginate : { 
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        };let i = index">
                        <th scope="col">{{list.vendorMasterId}}</th>
                        <th scope="col">{{list.name}}</th>
                        <th scope="col">{{list.contactPhone}}</th>
                        <th scope="col">{{list.contactEmail}}</th>
                        <th scope="col">{{list.latestStatus}}</th>
                        <td>
                            <i class="bi bi-eye-fill" (click)="getVendorById(list.vendorMasterId)" data-toggle="modal" data-target="#deleteModal"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="pagination-block" *ngIf="vendorList.length != 0">
                <pagination-controls
                    previousLabel="Prev"
                    nextLabel="Next"
                    (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
            </div>
        </div>
    </div>
</div> -->

<div class="profile-container">
    <div class="">
        <div class="profile-content">  
            <div class="personal-details">

              <div class="header-block">
                  <div class="header-title">
                      <p>List of Approved Venders</p>
                  </div>
                  <div class="add-block">
                    <div class="search">
                        <form autocomplete="off" >
                            <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey" placeholder="search">
                        </form>
                        <i class="bi bi-x-lg" (click)="refreshSearch()" *ngIf="searchKey != ''"></i>
                        <i class="bi bi-search" (click)="getVendorMasterBySearchAndStatus(0,10)"></i>
                    </div>
                  </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 25%;">Vendor Name</th>
                        <th style="width: 25%;">Vendor Description</th>
                        <th style="width: 20%;">Vendor Code</th>
                        <th style="width: 20%;">Vendor Status</th>
                        <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let list of vendorList | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">
      
                      <p style="width: 25%;">{{list.name}}</p>
                      <p style="width: 25%;">{{list.description}}</p>
                      <p style="width: 20%;">{{list.code}}</p>
                      <p style="width: 20%;">{{list.latestStatus}}</p>
                      <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <i *ngIf="actionControls.isView" (click)="getVendorById(list.vendorMasterId)" data-toggle="modal" data-target="#view" class="bi bi-eye-fill"></i>
                      </p>
                  </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && vendorList.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>
  
        </div>
    </div>
</div>

<div class="modal fade" id="view" tabindex="-1" data-backdrop="static" aria-labelledby="view" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Vendor Details
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg"></i>
                      </span>
                </h5>
            </div>
            <div class="modal-body" *ngFor="let data of sigleVendorData">
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Company Name</label>
                            <input value="{{data.name}}" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                        <div class="form-group">
                            <label>Contact Person Name</label>
                            <input value="{{data.contactName}}" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                        <div class="form-group">
                            <label>Contact Person Phone</label>
                            <input value="{{data.contactPhone}}" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                        <div class="form-group">
                            <label>Contact Person Email</label>
                            <input value="{{data.contactEmail}}" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                        <div class="form-group">
                            <label>Code</label>
                            <input type="text" value="{{data.name}}" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                        <div class="form-group">
                            <label>Type</label>
                            <input type="text" value="{{data.type}}" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-12" *ngIf="data.image != null && data.image != undefined && data.image != ''">
                        <div class="form-group image-view">
                            <label>Image </label>
                            <img [src]="data.image" alt="" srcset="">
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-12" *ngIf="data.documents.length != 0">
                        <label>Document </label>
                        <div  class="doc-image-view">
                            <div *ngFor="let doc of data.documents" >
                                <div class="" *ngIf="doc.type == 'image/png' || doc.type == 'image/jpeg'">
                                    <img [src]="doc.url" alt="" srcset="">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-6 col-lg-6" *ngFor="let key of data.keyValueList">
                        <div class="form-group">
                            <label>{{key.key}}</label>
                            <input value="{{key.value}}" type="text" class="form-control">
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <label>Address</label>
                        <div class="row addresse-block">
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>Name</label>
                                    <input type="text" value="{{data.geoAddress.name}}" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>Phone</label>
                                    <input type="text" value="{{data.geoAddress.phone1}}" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>Email</label>
                                    <input type="text" class="form-control" value="{{data.geoAddress.email}}">
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>Address</label>
                                    <input type="text" class="form-control" value="{{data.geoAddress.address}}">
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>Landmark</label>
                                    <input type="text" class="form-control" value="{{data.geoAddress.landmark}}">
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>City</label>
                                    <input type="text" class="form-control" value="{{data.geoAddress.city}}">
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>Town</label>
                                    <input type="text" class="form-control" value="{{data.geoAddress.town}}">
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>District</label>
                                    <input type="text" class="form-control" value="{{data.geoAddress.district}}">
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>Post Code</label>
                                    <input type="text" class="form-control" value="{{data.geoAddress.postCode}}">
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>State</label>
                                    <input type="text" class="form-control" value="{{data.geoAddress.state}}">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
            <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </span>
          </h5>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="">Note</label>
            <textarea name="" id="" cols="30" rows="3" class="form-control" [(ngModel)]="note"></textarea>
          </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="blockVendor()" class="btn btn-primary">Block</button>
        </div>
      </div>
    </div>
  </div>
</div>